export default {
    customer: 1,
    customerBranch: 5,
    supplier: 10,
    supplierBranch: 15,
    admin: 100
}
